import React from "react"

export default function Tile({ description, link, colour, name, icon, onClick }) {
  description?.props?.children[1] === "No matches" ? (link = link.split("?")[0]) : null
  return (
    <a
      href={link || "#"}
      onClick={(ev) => {
        if (onClick) {
          ev.stopPropagation()
          ev.preventDefault()
          onClick()
        }
      }}
      className="frontpage-tile"
      style={{
        display: "inline-flex",
        flexDirection: "column",
        width: "200px",
        height: "220px",
        background: "#ddd",
        margin: "30px",
        textAlign: "center",
      }}
    >
      <div
        style={{
          background: colour,
          width: "100%",
          height: "20px",
          flex: "none",
        }}
      />
      <div
        style={{
          paddingTop: "10px",
          paddingBottom: "20px",
          paddingLeft: "5px",
          paddingRight: "5px",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <h5>{name}</h5>
        <div
          style={{
            marginTop: "5px",
          }}
        >
          <span className={`fa fa-${icon}`} style={{ fontSize: "200%" }} aria-hidden="true" />
        </div>
        {typeof description === "string" ? (
          <p
            style={{
              marginTop: "10px",
              flexShrink: 1,
            }}
          >
            {description}
          </p>
        ) : (
          <>{description}</>
        )}
      </div>
    </a>
  )
}
